import { render } from "./theses_evaluation.vue?vue&type=template&id=390c6e4a"
import script from "./theses_evaluation.vue?vue&type=script&lang=js"
export * from "./theses_evaluation.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__